import { doc, setDoc, deleteDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebaseDDH';

const COLLECTION = 'includedItems';

function slugify(label) {
  return label
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 60) || 'item';
}

// Doc ID is derived from the label itself, so adding the same item twice
// (e.g. "Home screen" again from a different link) just reuses the existing
// entry instead of creating a duplicate in the library.
export async function addIncludedItem(label) {
  const trimmed = label.trim();
  if (!trimmed) return;
  await setDoc(doc(db, COLLECTION, slugify(trimmed)), {
    label: trimmed,
    createdAt: serverTimestamp(),
  }, { merge: true });
}

export async function deleteIncludedItem(id) {
  await deleteDoc(doc(db, COLLECTION, id));
}
